import styled from "styled-components"
import { theme } from "../../styles/theme"

export const SCalendar = styled.div`
  --ft-size-year: 18px;
  --ft-weight-year: 700;
  --indicator-size: 4px;
  --indicator-bg: orange;
  --calc-size: 20px;
  --width-day: 36px;
  --width-year: calc(var(--width-day) * 7 / 4);
  --height-year: calc(var(--width-year) * 0.77);
  --padding: 10px;
  --padding-domain: 5px;
  color: ${theme.colors.white};

  & button {
    cursor: pointer;
  }

  & > header {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    height: 50px;
    padding: 0 var(--padding);
    border-bottom: 1px solid ${theme.colors.black_bg2};

    & button {
      display: grid;
      place-items: center;
      &:hover {
        color: ${theme.colors.yellowgreen};
      }
    }
    & .front,
    & .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    & .calc {
      width: var(--calc-size);
      height: var(--calc-size);
    }
    & .domains {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 3px;
      padding: 0 var(--padding-domain);
    }
    & .domain {
      padding: var(--padding-domain);
      font-weight: 700;
    }
    & .rotate {
      transform: rotate(180deg);
    }
    & .back > button {
      padding: var(--padding-domain);
      font-weight: 700;
    }
  }

  & > aside {
    &.charDays {
      display: grid;
      grid-template-columns: repeat(7, var(--width-day));
      grid-template-rows: var(--width-day);
      justify-content: center;
      align-content: center;
      justify-items: center;
      align-items: center;
      color: lightgray;
    }
  }

  & > menu {
    display: grid;
    justify-content: center;
    align-content: center;
    padding: var(--padding);

    & > button {
      position: relative;
      border: 1px solid transparent;
    }
    & .active {
      background-color: ${theme.colors.green};
      color: white;
    }
    & .indicated {
      &::after {
        content: "";
        position: absolute;
        top: 3px;
        left: 50%;
        transform: translateX(-50%);
        width: var(--indicator-size);
        height: var(--indicator-size);
        border-radius: 50%;
        background-color: var(--indicator-bg);
      }
    }
  }

  &.year,
  &.month {
    & > menu {
      height: calc(var(--width-day) * 7 + var(--padding) * 2);
      font-size: var(--ft-size-year);
      font-weight: var(--ft-weight-year);
      grid-template-columns: repeat(4, var(--width-year));
      grid-template-rows: repeat(3, var(--height-year));

      & button {
        font-size: var(--ft-size-year);
        font-weight: var(--ft-weight-year);
        border-radius: calc(var(--height-year) / 2);
      }
    }
  }
  &.year {
    & > header {
      & .domain.year {
        color: ${theme.colors.yellowgreen};
      }
    }
  }
  &.month {
    & > header {
      & .domain.month {
        color: ${theme.colors.yellowgreen};
      }
    }
  }
  &.day {
    & > menu {
      grid-template-columns: repeat(7, var(--width-day));
      grid-template-rows: repeat(6, var(--width-day));

      & button {
        border-radius: 50%;

        &.today {
          border-color: ${theme.colors.yellowgreen};
        }
        &:disabled {
          pointer-events: none;
          color: gray;
        }
      }
    }
  }
`